/**
 * Stap 5: de argumenten nog eens nakijken en afronden. Daarna het scherm
 * "Goed gedaan!", en de twee schermen voor als er niets te doen is: geen
 * actieve opdracht, of geen verbinding.
 */
import React from 'react';
import { Check } from 'lucide-react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

export function Afronden({ api, discussion, argumenten, onAanpassen, onAfgerond }) {
  const rondAf = async () => {
    try {
      const data = await api.rondAf(discussion.discussion_id);
      if (data.success) onAfgerond();
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.card}>
      <div style={styles.stepHeader}>
        <span style={styles.stepNumber}>5</span>
        <div><h2 style={styles.stepTitle}>Bijna klaar!</h2><p style={styles.stepSubtitle}>Check je argumenten</p></div>
      </div>
      <div style={styles.summaryBox}>
        <h3>✅ VOOR:</h3>
        <ul>{argumenten.voor.filter(a => a.trim()).map((a, i) => <li key={i}>{a}</li>)}</ul>
        <h3>❌ TEGEN:</h3>
        <ul>{argumenten.tegen.filter(a => a.trim()).map((a, i) => <li key={i}>{a}</li>)}</ul>
      </div>
      <div style={styles.buttonRow}>
        <button onClick={onAanpassen} style={styles.btnSecondary}>← Aanpassen</button>
        <button onClick={rondAf} style={styles.btn}><Check size={20} /> Afronden</button>
      </div>
    </div>
  );
}

export function Klaar() {
  return (
    <div style={styles.card}>
      <div style={styles.emptyState}>
        <span style={styles.emptyIcon}>🎉</span>
        <h2>Goed gedaan!</h2>
        <p>Je hebt de discussie succesvol afgerond.</p>
        <p style={styles.hint}>Je leraar kan nu je argumenten bekijken.</p>
      </div>
    </div>
  );
}

export function GeenSessie() {
  return (
    <div style={styles.card}>
      <div style={styles.emptyState}>
        <span style={styles.emptyIcon}>📭</span>
        <h2>Geen actieve opdracht</h2>
        <p>Je leraar heeft nog geen discussie-opdracht voor je klaargezet.</p>
      </div>
    </div>
  );
}

export function Fout({ melding, onOpnieuw }) {
  return (
    <div style={styles.card}>
      <h2>😕 Er ging iets mis</h2>
      <p>{melding}</p>
      <button onClick={onOpnieuw} style={styles.btn}>Opnieuw proberen</button>
    </div>
  );
}

const styles = {
  ...basis,
  summaryBox: { background: kleur.vlak, padding: '20px', borderRadius: '12px', marginBottom: '24px' },
  hint: { color: kleur.stiller, fontSize: '14px', marginTop: '16px' },
};
